export const FeatureConfig = {
  apiUrl: 'VITE_API_URL',
  apiEventsUrl: 'VITE_API_EVENTS_URL',
  apiAdminUrl: 'VITE_API_ADMIN_URL',
  countries: 'VITE_COUNTRIES',
  growthbookURL: 'VITE_GROWTHBOOK_URL',
  growthbookSdkKey: 'VITE_GROWTHBOOK_SDK_KEY',
  inventoryApiUrl: 'VITE_INVENTORY_API_URL',
  omsApiUrl: 'VITE_OMS_API_URL',
  shellMFEUrl: 'VITE_SHELL_MFE_URL'
}

export const FeatureToggle = {
  isOktaGlobal: 'VITE_OKTA_GLOBAL_ENABLED',
  countryHeader: 'VITE_FEATURE_COUNTRY_HEADER_ENABLED',
  userRole: 'VITE_FEATURE_USER_ROLE_ENABLED',
  userGuide: 'VITE_FEATURE_USER_GUIDE_ENABLED',
}
